import { useAct } from 'DashboardUser/store'
import Loading from 'Shared/components/Loading'

import DashboardTargetTable from './DashboardTargetTable'
import DashboardInstructions from './DashboardInstructions'
import { RingroundSnackbar } from 'Shared/components'

export default function PageContainer({ dashboardId }) {
  const act = useAct()
  const currentPage = useSel(s => s.local.currentPage)
  const [showInstructions, setShowInstructions] = useState(false)

  useEffect(() => {
    if (!dashboardId) return

    act.app.load(dashboardId)
    act.app.loadMe()
    act.app.reloadTargets()

    const storageKey = `dashboard-instructions-viewed-${dashboardId}`
    const hasViewed = localStorage.getItem(storageKey)
    setShowInstructions(!hasViewed)
    localStorage.setItem(storageKey, 'true')
  }, [dashboardId])

  useEffect(() => {
    act.app.reloadTargets()
  }, [currentPage])

  const name = useSel(s => s.dashboard.name)
  const instructions = useSel(s => s.dashboard.instructions)
  const loaded = useSel(s => s.app.loaded)
  const { firstName } = useSel(s => s.app.currentUser)

  return <div className='dashboard-user-root'>
    <RingroundSnackbar />
    <div className='topbar'>
      <div className='back'>
        <a href='/'>
          <SvgIconsBackCaret />
          Back
        </a>
      </div>
      <div className='titles'>
        <h1>Hello, {firstName}! 👋</h1>
        <h2>{name}</h2>
      </div>
      {instructions && !showInstructions && (
        <div className='view-instructions'>
          <button onClick={() => setShowInstructions(true)}>View instructions</button>
        </div>
      )}
    </div>

    {instructions && showInstructions && (
      <DashboardInstructions onClose={setShowInstructions} />
    )}
    <div className='content'>
      {loaded ? <DashboardTargetTable /> : <Loading />}
    </div>
  </div>
}
